import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "tw-elements-react/dist/css/tw-elements-react.min.css";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { sendToVercelAnalytics } from "./vitals";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

// Try to load critical fonts quickly using the CSS Font Loading API.
// If they load within `FAST_FONT_TIMEOUT_MS` we add `fonts-loaded`
// to `document.documentElement` so CSS can apply the webfonts.
function tryLoadCriticalFonts(timeoutMs = 500) {
  if (!document || !document.fonts || !document.fonts.load) return;
  const families = ["FrutigerLTStd-Light", "FrutigerCE-Roman", "FrutigerCE4"];
  const loads = families.map((f) => document.fonts.load(`1rem "${f}"`));
  const all = Promise.all(loads);
  const timeout = new Promise((resolve) => setTimeout(resolve, timeoutMs, "timeout"));
  Promise.race([all, timeout]).then((res) => {
    if (res !== "timeout") {
      try {
        document.documentElement.classList.add("fonts-loaded");
      } catch (e) {}
    }
  }).catch(() => {
    // ignore failures — we'll just keep fallback fonts
  });
}

tryLoadCriticalFonts(500);

// Allow disabling React.StrictMode locally via env var for easier debugging
// of lifecycle/timing issues (set REACT_APP_DISABLE_STRICT_MODE=true).
const DisableStrict = process.env.REACT_APP_DISABLE_STRICT_MODE === "true";
const Wrapper = DisableStrict ? (({ children }) => children) : StrictMode;

root.render(
  <Wrapper>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Wrapper>
);

reportWebVitals(sendToVercelAnalytics);
